module.exports = __webpack_public_path__ + "img/eIDCN.3d4fe9b2.png";